import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=03b0b128&scoped=true&"
import script from "./ShowForm.vue?vue&type=script&lang=js&"
export * from "./ShowForm.vue?vue&type=script&lang=js&"
import style0 from "./ShowForm.vue?vue&type=style&index=0&id=03b0b128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0b128",
  null
  
)

export default component.exports